module.exports = __webpack_public_path__ + "favicon-9f6c20b2f346733d27972285490e9579.ico";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/favicon.ico
// module id = 39
// module chunks = 0